var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('expose',{staticClass:"game-video-expose",attrs:{"active":_vm.videoId != null},on:{"expose-close":function($event){_vm.$root.$data.gameVideoId = null}}},[_c('game-video',{ref:"videoWindow",staticClass:"game-video-expose__video",style:({
		'width' : _vm.videoWidth + 'px'
	}),attrs:{"videoId":_vm.videoId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58935578","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/GameVideoExpose.vue
// module id = null
// module chunks = 